import { deserialize, serializable } from 'serializr';
import { PageObject } from '@testsigma/organism';
import { Base } from '@models/base.model';

export class SalesforceMetadataObject extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public label: string;
  @serializable
  public isCustom: boolean;
  @serializable
  public isLayoutable: boolean;
  @serializable
  public isMruEnabled: boolean;
  @serializable
  public applicationVersionId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SalesforceMetadataObject, input));
  }
}
